const header = document.querySelector('header.header');

document.querySelectorAll('[data-ref="services-menu-item"]').forEach(anchor => {
	let section = document.querySelector(anchor.getAttribute('href'));
	if (section) {
		anchor.addEventListener('click', (e) => {
			e.preventDefault();

			let sectionPosition = section.getBoundingClientRect().top;
			let scrollPosition = sectionPosition + window.scrollY - header.clientHeight;
	
			window.scrollTo({
				top: scrollPosition,
				behavior: "smooth"
			});
		});
	}
});

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener('click', function (e) {
		e.preventDefault();
		let header = document.querySelector('header.header');
		let div = document.querySelector(this.getAttribute('href'));

		if (div) {
			let top = div.getBoundingClientRect().top;
			let scrollPosition = top + window.scrollY - header.clientHeight;

			window.scrollTo({
				top: scrollPosition,
				behavior: "smooth"
			});
		}
	});
})